import React, { } from "react";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { NavLink } from "react-router-dom";
const responsiveSettings = {
    0: {
        items: 1
    },
    768: {
        items: 3
    },
    991: {
        items: 3
    }
};

class Services extends React.Component {
    render() {
        return (
            <section className="service_section layout_padding" id="service_section">
                <div className="container">
                    <div className="heading_container heading_center ">
                        <h2>
                            Our OET Preparation Services
                        </h2>
                        <p className="col-lg-8 px-0">
                            At YesEd Academy, we are dedicated to providing top-tier OET preparation services designed to meet the unique needs of healthcare professionals aiming to excel in the Occupational English Test. Our comprehensive range of services is tailored to enhance your language proficiency, healthcare-specific communication skills, and overall OET performance.
                        </p>
                    </div>
                    <div className="service_container">
                        <div className="carousel-wrap ">

                            <div className="service_owl-carousel">
                                <OwlCarousel items={3} margin={0} responsive={responsiveSettings} nav={true} center={true} autoplay={true} loop={true} >

                                    <div className="item">
                                        <div className="box ">
                                            <div className="img-box">
                                                <img src="images/s1.png" alt="img1" />
                                            </div>
                                            <div className="detail-box">
                                                <h5>
                                                    OET Preparation Courses
                                                </h5>
                                                <p>
                                                    Our specialized OET Preparation Courses are meticulously designed to equip you with the skills needed to succeed in all four language domains: Listening, Reading, Writing, and Speaking. Our curriculum is structured around authentic healthcare scenarios to ensure your readiness for real-world interactions
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="box ">
                                            <div className="img-box">
                                                <img src="images/s2.png" alt="img2" />
                                            </div>
                                            <div className="detail-box">
                                                <h5>
                                                    Expert Instructors
                                                </h5>
                                                <p>
                                                    Learn from experienced language trainers and healthcare experts who understand the intricacies of the OET. Our instructors bring their industry insights and instructional expertise to guide you throughout your preparation journey
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="box ">
                                            <div className="img-box">
                                                <img src="images/s3.png" alt="img3" />
                                            </div>
                                            <div className="detail-box">
                                                <h5>
                                                    Personalized Learning Paths
                                                </h5>
                                                <p>
                                                    We recognize that each student has unique strengths and areas for improvement. Our diagnostic assessments help us tailor a personalized learning path that maximizes your progress, ensuring you focus on areas that matter most
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="box ">
                                            <div className="img-box">
                                                <img src="images/s4.png" alt="img4" />
                                            </div>
                                            <div className="detail-box">
                                                <h5>
                                                    Realistic Practice Simulations
                                                </h5>
                                                <p>
                                                    Practice makes perfect, especially when it comes to OET success. Our realistic practice simulations mirror the actual healthcare environment, enabling you to confidently navigate patient consultations, role-plays, and communication tasks
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="box ">
                                            <div className="img-box">
                                                <img src="images/s5.png" alt="img5" />
                                            </div>
                                            <div className="detail-box">
                                                <h5>
                                                    Comprehensive Study Materials
                                                </h5>
                                                <p>
                                                    Access a rich repository of OET-specific resources, including practice tests, vocabulary guides, sample materials, and more. These materials are designed to enhance your comprehension of medical terminology and healthcare communication
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="box ">
                                            <div className="img-box">
                                                <img src="images/s6.png" alt="img6" />
                                            </div>
                                            <div className="detail-box">
                                                <h5>
                                                    Mock Tests and Performance Analysis
                                                </h5>
                                                <p>
                                                    Measure your readiness with our mock OET tests that closely resemble the actual exam conditions. Receive detailed performance analysis and feedback, allowing you to fine-tune your skills and focus on areas that require improvement
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="box ">
                                            <div className="img-box">
                                                <img src="images/s7.png" alt="img7" />
                                            </div>
                                            <div className="detail-box">
                                                <h5>
                                                    Continuous Support
                                                </h5>
                                                <p>
                                                    Our commitment to your success extends beyond the classroom. Benefit from ongoing support, doubt-clearing sessions, and expert guidance as you progress through your OET journey
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="box ">
                                            <div className="img-box">
                                                <img src="images/s8.png" alt="img8" />
                                            </div>
                                            <div className="detail-box">
                                                <h5>
                                                    Success Stories
                                                </h5>
                                                <p>
                                                    Discover the inspiring success stories of healthcare professionals who have achieved their OET goals with YesEd Academy. These stories exemplify how our services have transformed careers and opened doors to new opportunities
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                    <div className="btn-box">
                        <NavLink className="nav-link" to="/services">
                            Read More
                        </NavLink>
                    </div>
                </div>
            </section>


        );
    }
}

export default Services;
